import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import SearchLegalManagement from '../legalManagement/SearchLegalManagement'
// import TableLealManagement from '../legalManagement/TableLealManagement'
import TableTrackingHistoryLaw from './TableTrackingHistoryLaw'
import {
  searchFollowHistoryPage,
  getFollowHistoryList,
  getFollowById,
} from '../../redux/actions/legalFollowHistory'
import LitigationView from '../saveLawTracking/LitigationView'
import TrackingHistoryLawResultTable from './TrackingHistoryLawResultTable'
import TrackingHistoryLawResultView from './TrackingHistoryLawResultView'
import ConfirmWidget from '../confirm/ConfirmWidget'
import AlertWidget from '../confirm/AlertWidget'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ViewButton from '../../components/buttons/viewButton/ViewButton'

export default function TrackingHistoryLawWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [active, setActive] = useState(props.schema.activeEventKey)
  const [dataTable, setDataTable] = useState()
  const [searchForm, setSearchForm] = useState()
  const [selectedLaw, setSelectedLaw] = useState()
  const [trackHistoryLawListAndInfo, setTrackHistoryLawListAndInfo] = useState()
  const [lawDetail, setLawDetail] = useState()

  const [isSelectLitagation, setIsSelectLitagation] = useState(false)

  useEffect(() => {
    if (formSchema) {
      setSearchForm(formSchema.searchForm)
      setDataTable(formSchema.searchResult)
    }
  }, [formSchema])

  const handleGetSchema = async (data) => {
    setIsLoading(true)
    startLoading()
    try {
      const request = {
        lawType: data.lawType,
        department: data.department,
        projectCode: data.projectCode,
        projectName: data.projectName,
        docNumberOfPurchase: data.docNumberOfPurchase,
        contractNumberRef: data.contractNumberRef,
        lawStatus: data.lawStatus,
        lawSubStatus: null,
        litigationCode: null,
        litigationName: null,
        pageNumber: data?.pageNumber || 1,
        pageSize: data?.pageSize || 5,
      }

      const _schema = await searchFollowHistoryPage(request)
      setDataTable(_schema.searchResult)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetTrackingHistoryLaw = async (rowData, pageSize, pageNumber) => {
    console.log('handleGetTrackingHistoryLaw => ', rowData, pageSize, pageNumber)

    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getFollowHistoryList(
        rowData.id,
        rowData.litigationCode,
        pageSize || 1,
        pageNumber || 5
      )
      setTrackHistoryLawListAndInfo(_schema)
      setSelectedLaw(rowData)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmitSearchLegalManagement = (data) => {
    console.log('onSubmitSearchLegalManagement data ', data)

    handleGetSchema(data)
  }

  const handleCancelData = () => {
    console.log('handleCancelData')
  }

  const handelGetSchemaOnReload = async (pageSize, pageNumber) => {
    console.log('handelGetSchemaOnReload ', pageSize, pageNumber)

    const request = {
      lawType: getValues('lawType'),
      department: getValues('department'),
      projectCode: getValues('projectCode'),
      projectName: getValues('projectName'),
      docNumberOfPurchase: getValues('docNumberOfPurchase'),
      contractNumberRef: getValues('contractNumberRef'),
      lawStatus: getValues('lawStatus'),
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 5,
    }

    handleGetSchema(request)
  }

  const handleOnSelectRowData = (rowData) => {
    console.log('select rowData', rowData)

    handleGetTrackingHistoryLaw(rowData)
  }

  const handelGetSchemaOnReloadHistoryList = async (pageSize, pageNumber) => {
    console.log('handelGetSchemaOnReloadHistoryList => ', selectedLaw, pageSize, pageNumber)
    handleGetTrackingHistoryLaw(selectedLaw, pageSize, pageNumber)
  }

  const handleOnSelectRowDataHistory = async (rowDataHistory) => {
    console.log('select rowDataHistory', rowDataHistory)

    setIsLoading(true)
    startLoading()
    try {
      const response = await getFollowById(rowDataHistory.id)

      setLawDetail(response.inputForm)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <>
      {searchForm && !trackHistoryLawListAndInfo && (
        <Panel shaded collapsible defaultExpanded header={formSchema.header || 'ค้นหา'} bordered>
          <SearchLegalManagement
            schema={searchForm}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            active={active}
            onSubmitData={handleSubmit(onSubmitSearchLegalManagement)}
            onCancelData={handleCancelData}
          />
        </Panel>
      )}

      {dataTable && !trackHistoryLawListAndInfo && (
        <div style={{ marginTop: 30 }}>
          <TableTrackingHistoryLaw
            schema={dataTable}
            pagination={true}
            loading={isLoading}
            onReload={handelGetSchemaOnReload}
            onSelect={handleOnSelectRowData}
          />
        </div>
      )}

      {trackHistoryLawListAndInfo && (
        <>
          <ViewButton
            icon="backward"
            style={{ marginBottom: 10 }}
            onClick={() => setTrackHistoryLawListAndInfo()}
          >
            ย้อนกลับ
          </ViewButton>

          {trackHistoryLawListAndInfo?.litigationInfo && (
            <LitigationView schema={trackHistoryLawListAndInfo?.litigationInfo} />
          )}

          <div style={{ marginTop: 20 }}>
            <TrackingHistoryLawResultTable
              schema={trackHistoryLawListAndInfo}
              pagination={true}
              loading={isLoading}
              onReload={handelGetSchemaOnReloadHistoryList}
              onSelect={handleOnSelectRowDataHistory}
            />
          </div>

          <ViewButton
            icon="backward"
            style={{ marginTop: 10, marginBottom: 10 }}
            onClick={() => setTrackHistoryLawListAndInfo()}
          >
            ย้อนกลับ
          </ViewButton>
        </>
      )}

      <AlertWidget
        show={lawDetail != '' && lawDetail != null && lawDetail != undefined}
        size="full"
        detail={
          <TrackingHistoryLawResultView schema={lawDetail} title={'รายละเอียดการติดตามคดี'} />
        }
        onClose={() => setLawDetail('')}
      />
    </>
  )
}
